<template>
  <li class="offer-feature">
    <img src="@/assets/icons/tick.svg" alt="Tick Icon" class="tick-icon" />
    <slot>
      {{ title }}
    </slot>
  </li>
</template>

<script>
export default {
  name: "UpgradeOfferFeature",
  props: {
    title: {
      default: "",
      type: String,
    },
  },
};
</script>

<style scoped>
.offer-feature {
  @apply text-grey-darkest text-xs font-bold font-sans;

  @screen md {
    @apply text-sm;
  }
}

.tick-icon {
  @apply m-0;
  width: 14px;

  @screen sm {
    @apply mr-1;
  }
}
</style>
